import { Row, Col, Carousel, Icon } from 'antd';
import {WeaLocaleProvider, WeaTable} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import { isEqual, isEmpty } from 'lodash';
import { formatData, loadRemind, openLinkUrl } from '../../util/common';
import objectAssign from 'object-assign';
//文档中心元素
class NewsType extends React.Component {
    constructor(props) {
        super(props);
    }
    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
    }
    render() {
        const { eid, data, esetting={}, canEdit } = this.props;
        const { linkmode } = esetting;
        const { tabsetting={}, srcStyle={} } = data;
        const {autoheight = '0', pictureheight = '108px', picturewidth = '120px'} = srcStyle;
        const { abstractColor = '#797979', abstractFont = '微软雅黑', abstractSize = '12', abstractstyle, abstractWeight = '0',
            titleColor = '#000000', titleFont = '微软雅黑', titleSize = '16', titlestyle,
            titleWeight= '0' } = tabsetting.style;
        const list = data.data;
        if (list.length === 0){
            return (
                <div className = "ant-table-placeholder">
                   <span> <i className = "anticon anticon-frown"></i>{getLabel(83553, '暂无数据')}</span>
                </div>
            );
        }
        //tab设置信息
        const { height, width, showModeId, imgs } = tabsetting;
        let columns = new Array;
        let imgStyle = {
            width: picturewidth,
            height: pictureheight
        };
        let style = {
            verticalAlign: 'top',
            width: picturewidth,
            height: pictureheight
        };
        if(autoheight == '1'){
            imgStyle = {
                verticalAlign: 'top',
                width: picturewidth,
                height: 'auto'
            };
            style = {
                verticalAlign: 'top',
                width: picturewidth,
                height: 'auto'
            };
        }
        let listStyle2 = {
            width: '100%',
            height: '100%'
        };
        if(autoheight == '0' && imgStyle.height && imgStyle.height.indexOf('px')!=-1 && imgStyle.width.indexOf('px')!=-1){
            listStyle2 = {
                width: imgStyle.width,
                height: imgStyle.height
            };
        }

        let docHtml = '';
        switch (parseInt(showModeId)) {
            case 2: //上图式
                imgStyle['margin'] = '0 auto';
                let lHtml = list.map((item, i) => {
                    let imghtml = null;
                    if (!isEmpty(imgs)) {
                        let img = imgs[i];
                        if (typeof img == 'object' && img.length > 1) {
                            imghtml = <div id={`news_silde_${eid}`} className="news-silde">
                                <Carousel autoplay >
                                    {img.map(o => {
                                        return <div><ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link} eid={eid} src={o} style={listStyle2}/></div>
                                    })}
                                </Carousel>
                            </div>
                        } else {
                            imghtml = <ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link}  eid={eid} src={img}/>
                        }
                    }
                    let list_new = [];
                    for (var i in item){
                        if(i != 'summary' && i != 'docsubject' && i != 'doccreater'){
                            list_new.push(item[i])
                        }
                    }
                    return <div id={`news_${eid}`} >
                        <div style={imgStyle}>{imghtml}</div>
                        <div style={{width: imgStyle.width, margin: '0 auto', paddingTop: '10px'}}>
                            {
                                item.docsubject ? <div style={{marginRight: '10px' , marginBottom: '10px'}}>{loadRemind(item.docsubject, esetting.linkmode, esetting.isremind, undefined,undefined,'7_DY', eid, style={ fontFamily: 'PingFangSC-Regular',
                                        fontSize: '14px !important', color: '#333333', letterSpacing: '-0.09px'})}</div>
                                    : <div style={{ marginTop: '10px', marginRight: '10px' , marginBottom: '10px'}}></div>
                            }
                            {item.summary && <div style={{marginBottom:'10px'}}><span style={{display: '-webkit-box', overflow: 'hidden', textOverflow: 'ellipsis', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical'}}>{item.summary}</span></div>}
                            <div style={{display: 'inline-block', position: 'relative', width: '100%', height: '32px'}}>
                                {item.doccreater ? <div style={{display: 'inline-block' , marginRight: '10px' ,marginBottom: '10px', width: '60px'}}>{loadRemind(item.doccreater, esetting.linkmode, esetting.isremind, undefined,undefined,'7_DY', eid)}</div> : <div style={{display: 'inline-block' ,marginTop: '10px' , marginRight: '10px' ,marginBottom: '10px'}}></div>}
                                <div style={{display: 'inline-block', bottom: '15px', float: 'right', width: 'calc(100% - 60px - 10px)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                    {
                                        list_new.map((item_new) => {
                                            return  <div style={{display: 'inline-block', fontSize: '12px', color: '#999999', letterSpacing: '-0.08px'}}>{item_new}</div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                });
                docHtml = <div>{lHtml}</div>
                break;
            case 3: //左图式
                let html = list.map((item, i) => {
                    let imghtml = null;
                    if (!isEmpty(imgs)) {
                        let img = imgs[i];
                        if (typeof img == 'object' && img.length > 1) {
                            img = img.filter(item => {
                                if(item != '/images/homepage/noimgdefault_wev8.jpg'){ return item; }
                            })
                            imghtml = <div id={`news_silde_${eid}`} className="news-silde">
                                <Carousel autoplay >
                                    {img.map(o => {
                                        return <div><ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link} eid={eid} src={o} style={listStyle2}/></div>
                                    })}
                                </Carousel>
                            </div>
                        } else {
                            imghtml = <ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link}  eid={eid} src={img}/>
                        }
                    }
                    let style_fs = objectAssign({}, imgStyle, {float:'left', marginBottom: '15px'});
                    let list_new = [];
                    for (var i in item){
                        if(i != 'summary' && i != 'docsubject' && i != 'doccreater'){
                            list_new.push(item[i])
                        }
                    }

                    return <div style={{overflow: 'auto', overflowY: 'hidden', width:'100%',marginBottom:'10px'}}>
                        <div style={style_fs}> {imghtml}</div>
                        <div style={{overflow: 'hidden', paddingLeft: '3px'}}>
                            {
                                item.docsubject ? <div style={{ marginTop: '10px', marginRight: '10px' }}>{loadRemind(item.docsubject, esetting.linkmode, esetting.isremind, undefined,undefined,'7_DY', eid,style={ fontFamily: 'PingFangSC-Regular',
                                    fontSize: '14px !important', color: '#333333', letterSpacing: '-0.09px'})}</div>
                                    :<div style={{ marginTop: '10px', marginRight: '10px' , marginBottom: '10px'}}></div>
                            }
                            {
                                item.summary && <div><span style={{width: '99%', overflow: 'hidden', textOverflow: 'ellipsis', WebkitLineClamp: '1',
                                    WebkitBoxOrient: 'vertical', display: '-webkit-box',  marginBottom: '10px'}}>{item.summary}</span></div>
                            }
                            <div style={{display: 'inline-block', position: 'relative', width: '100%'}}>
                                {item.doccreater ? <div style={{display: 'inline-block' , marginRight: '10px' ,marginBottom: '10px'}}>{loadRemind(item.doccreater, esetting.linkmode, esetting.isremind, undefined,undefined,'7_DY', eid)}</div> : <div style={{display: 'inline-block' ,marginTop: '10px' , marginRight: '10px' ,marginBottom: '10px'}}></div>}
                                <div style={{display: 'inline-block', position: 'absolute', bottom: '15px', float: 'right', width: '100%'}}>
                                    {
                                        list_new.map((item_new) => {
                                            return  <div style={{display: 'inline-block', paddingLeft: '5px', fontSize: '12px', color: '#999999', letterSpacing: '-0.08px'}}>{item_new}</div>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                });
                docHtml = <div>{html}</div>
                break;
            case 4: //列表式2
                let html4 = null;
                let imghtml = null;
                let imghtml2=[];
                let j=0;
                const imgs_new = imgs.filter(item => {
                    if(item != '/images/homepage/noimgdefault_wev8.jpg'){ return item; }
                })
                if (!isEmpty(imgs)) {
                    if (imgs_new.length > 1) {
                        imgs.map((item,i) => {
                            imghtml2[j]=imgs[i];
                            j++;
                        });

                        if(imghtml2.length==0){
                            imghtml2[0]='/images/homepage/noimgdefault_wev8.jpg';
                        }
                        let ihtml = imghtml2.map((item, i) => {
                            let img = imghtml2[i];
                            if(!img) img = '/images/homepage/noimgdefault_wev8.jpg';
                            if(img == '/images/homepage/noimgdefault_wev8.jpg'){
                                return
                            }
                            // if (img.indexOf("|") !== -1) img = img.split("|")[0];
                            return <div><ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link} style={listStyle2} eid={eid} src={img}/></div>
                        });
                        imghtml = <div style={{height: style.height || '100%'}} id={`news_silde_${eid}`} className="news-silde">
                            <Carousel autoplay>
                                {ihtml}
                            </Carousel>
                        </div>
                    }else{
                        let img = imgs_new[0];
                        if(!img) img = '/images/homepage/noimgdefault_wev8.jpg';
                        if (img.indexOf("|") !== -1) img = img.split("|")[0];
                        imghtml = <div style={{height: style.height || '100%'}} id={`news_silde_${eid}`} className='news-silde'>
                                <div><ImgCom linkmode={linkmode} link={list[0] && list[0].docsubject && list[0].docsubject.link} style={listStyle2} eid={eid} src={img}/></div>
                        </div>
                    }
                }
                columns = formatData(list[0], esetting);
                style['paddingTop'] = '6px';
                html4 = <table style={{width: '100%',tableLayout: 'fixed'}}><tr>
                    <td style={style}>
                        {imghtml}
                    </td>
                    <td width="*" className="valign"><WeaTable columns={columns} showHeader={false} pagination={false} dataSource={list} size="small"/></td>
                </tr></table>;

                docHtml = <div>{html4}</div>
                break;
            case 5: //双列式
                columns = formatData(list[0], esetting);
                const evenData = new Array;
                const oddData = new Array;
                list.map((item, i) => {
                    if (i % 2 === 0) {
                        evenData.push(item);
                    } else {
                        oddData.push(item);
                    }
                });
                if(!isEmpty(evenData) && !isEmpty(oddData)){
                    docHtml = <div><Row>
                            <div className="ant-table-placeholder"><span><i className="anticon anticon-frown"></i>{getLabel(83553, '暂无数据')}</span></div>
                        </Row>
                    </div>
                }else {
                    docHtml = <div><Row>
                            <Col span={12} order={1}>
                                {!isEmpty(evenData) && <WeaTable columns={columns} showHeader={false} pagination={false} dataSource={evenData} size="small"/>}
                            </Col>
                            <Col span={12} order={2}>
                                {!isEmpty(oddData) && <WeaTable columns={columns} showHeader={false} pagination={false} dataSource={oddData} size="small"/>}
                            </Col>
                        </Row>
                    </div>
                }
                break;
            case 6: //摘要式
                let html6 = list.map((item, i) => {
                    let docsubject = item.docsubject || {};
                    let imghtml = null;
                    if (!isEmpty(imgs)) {
                        let img = imgs[i];
                        if (typeof img == 'object' && img.length > 1) {
                            img = img.filter(item => {
                                if(item != '/images/homepage/noimgdefault_wev8.jpg'){ return item; }
                            })
                            imghtml = <div id={`news_silde_${eid}`} className="news-silde">
                                <Carousel autoplay >
                                    {img.map(o => {
                                        return <div><ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link} eid={eid} src={o} style={listStyle2}/></div>
                                    })}
                                </Carousel>
                            </div>
                        } else {
                            imghtml = <ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link}  eid={eid} src={img}/>
                        }
                    }
                    let style_fs = objectAssign({}, imgStyle, {float:'left'});
                    return <div style={{width:'100%',paddingBottom:'20px',marginBottom:'5px',borderBottom: i !== (list.length - 1) ? '1px solid #dedede':'',overflow: 'hidden'}}>
                        <div style={style_fs}> {imghtml}</div>
                        <div style={{overflow: 'hidden', paddingLeft: '3px'}}>
                            <div style={{height:'32px',width:'99%'}}>
                                <div title={docsubject.name} onClick={openLinkUrl.bind(this, docsubject.link, esetting.linkmode)} style={{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp: 1,WebkitBoxOrient: 'vertical',cursor:'pointer'}}>{docsubject.name}</div>
                                {docsubject.img ? <ImgCom linkmode={linkmode} eid={eid} style={{verticalAlign: 'middle', marginTop: '-25px', marginLeft: '5px', cursor: 'pointer'}} alt="" src={docsubject.img}/> : ''}
                            </div>
                            <div title={item.summary} style={{height: '60px', lineHeight: '30px', color: 'rgb(105, 104, 104)', textOverflow: 'ellipsis', width: '99%',
                                overflow: 'hidden', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', display: '-webkit-box',  marginBottom: '10px'}}>{item.summary}</div>
                        </div>
                    </div>
                });
                docHtml = <div>{html6}</div>
                break;
            case 7: //摘要式2
                let listStyle3 = {
                    width: '100%',
                    height: '100%'
                };
                if(autoheight == '0'&& imgStyle.height && imgStyle.height.indexOf('px')!=-1){
                    listStyle3 = {
                        width: '100%',
                        height: imgStyle.height
                    };
                }
                let imghtml7 = null;
                let style_fs = objectAssign({}, imgStyle, {float: 'left', marginBottom: '15px'});
                let imghtml3= [];
                let m=0;
                if (!isEmpty(imgs)) {
                    if (imgs.length > 1) {
                        imgs.map((item,i) => {
                            if(imgs[i]!='/images/homepage/noimgdefault_wev8.jpg'){
                                imghtml3[m]=imgs[i];
                                m++;
                            }
                        })
                        if(imghtml3.length==0){
                            imghtml3 = ['/images/homepage/noimgdefault_wev8.jpg'];
                        }
                        let ihtml = imghtml3.map((item, i) => {
                            let img = imghtml3[i];
                            if(!img) img = '/images/homepage/noimgdefault_wev8.jpg';
                            if (img.indexOf("|") !== -1) img = img.split("|")[0];
                            return <div><ImgCom linkmode={linkmode} link={list[i] && list[i].docsubject && list[i].docsubject.link} style={listStyle3} eid={eid} src={img}/></div>
                        });
                        imghtml7 = <div id={`news_silde_${eid}`} className="news-silde">
                            <Carousel autoplay>
                                {ihtml}
                            </Carousel>
                        </div>
                    }else{
                        let img = imgs_new[0];
                        if(!img) img = '/images/homepage/noimgdefault_wev8.jpg';
                        if (img.indexOf("|") !== -1) img = img.split("|")[0];
                        imghtml7 = <div style={{height: '100%'}} id={`news_silde_${eid}`} className='news-silde'>
                                <div><ImgCom linkmode={linkmode} link={list[0] && list[0].docsubject && list[0].docsubject.link} style={listStyle3} eid={eid} src={img}/></div>
                        </div>
                    }
                }
                let html7 = list.map((item, i) => {
                    let docsubject = item.docsubject || {};
                    return <div style={{float:'left',paddingLeft:'10px',width:'100%',borderBottom:i !== (list.length - 1) ? '1px solid #dedede':''}}>
                        <div style={{height:'32px',width:'99%'}}>
                            <div title={docsubject.name} onClick={openLinkUrl.bind(this, docsubject.link, esetting.linkmode)} style={{display:'inline-block',maxWidth:'calc(100% - 8px)',height:'100%',lineHeight:'32px',fontSize:'14px',fontWeight:'bold',color:'#666666',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp: 1,WebkitBoxOrient: 'vertical',cursor:'pointer'}}>{docsubject.name}</div>
                            {docsubject.img ? <ImgCom linkmode={linkmode} eid={eid} style={{margin: '0 0 11px 2px'}} alt="" src={docsubject.img}/> : ''}
                        </div>
                        <div title={item.summary} style={{display: '-webkit-box', maxHeight:'60px',width:'99%',lineHeight:'30px',color: '#696868',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp: 2,WebkitBoxOrient: 'vertical', marginBottom:'10px'}}>{item.summary}</div>
                    </div>

                });
                docHtml =  <div><div style={{width:'100%',marginBottom:'10px'}}>
                    <div style={style_fs}> {imghtml7}</div>
                    <div style={{overflow: 'hidden'}}>{html7}</div>
                </div></div>
                break;
            case 8: //头条式
                let item = list[0];
                let docsubject = item.docsubject || {};
                let tableHtml = '';
                let newList = [...list];
                if(list.length > 1){
                    let columns = formatData(list[1], esetting);
                    tableHtml = <WeaTable columns={columns} showHeader={false} pagination={false} dataSource={newList.slice(1,list.length)} size="small"/>
                }
                docHtml = <div><div style={{overflow:'hidden',width:'100%',marginBottom:'10px'}}>
                    <div style={{width:'100%'}}>
                        <div style={{paddingLeft:'10px',width:'100%',borderBottom:'1px solid #dedede'}}>
                            <div style={{height:'32px',width:'99%'}}>
                                <div title={docsubject.name} onClick={openLinkUrl.bind(this, docsubject.link, esetting.linkmode)} style={{fontSize: titleSize.indexOf("px")> 0 ? titleSize : titleSize +'px' || '16px', color:titleColor || '#000000',fontFamily:titleFont || '微软雅黑', fontWeight:titleWeight == '0' ? 'normal' : 'bold ', fontStyle: titlestyle || 'normal', display: 'inline-block',maxWidth: 'calc(100% - 8px)',height:'100%',lineHeight:'32px',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp: 1,WebkitBoxOrient: 'vertical',cursor:'pointer', width: '100%'}}>{docsubject.name}
                                {docsubject.img ? <ImgCom linkmode={linkmode} eid={eid} style={{margin: '0 0 11px 2px'}} alt="" src={docsubject.img}/> : ''}</div>
                            </div>
                            <div title={item.summary} style={{fontSize: abstractSize.indexOf('px') > 0 ? abstractSize : abstractSize +'px'||'16px',color:abstractColor || '#000000', fontFamily: abstractFont ||'微软雅黑', fontWeight: abstractWeight == '0' ? 'normal' : 'bold', fontStyle: abstractstyle || 'normal',width:'99%',overflow:'hidden',textOverflow:'ellipsis',WebkitLineClamp: 2,WebkitBoxOrient: 'vertical',display: '-webkit-box', marginBottom: '10px'}}>{item.summary}</div>
                        </div></div>
                </div>
                    {tableHtml}
                </div>
                break;
            case 1: //列表式
            default:
                columns = formatData(list[0], esetting);
                docHtml = <WeaTable style={{fontSize: '20px'}} columns={columns} showHeader={false} pagination={false} dataSource={list} size="small"/>
                break;
        }
        // return <AddNewCom canEdit={this.props.canEdit} catalogIds={tabsetting.catalogIds} catalogId={tabsetting.catalogId}>{docHtml}</AddNewCom>
        return docHtml;
    }
}

class AddNewCom extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isShowAdd: false,
            color: '#939393',
        }
        this.handleOpen = this.handleOpen.bind(this);
    }
    handleOpen(){
        const { catalogId, catalogIds } = this.props;
        if(catalogId){
            openLinkUrl('/spa/document/index.jsp?secid='+catalogId+'&isEdit=1&moudleFrom=portal','2');
        }else{
            openLinkUrl('/spa/document/static/index.html#/main/document/add?openNewWindow=0&moudleFrom=portal&secids='+catalogIds,'2');
        }
    }
    render(){
        const { children, canEdit } = this.props;
        if(canEdit){
            return <div className=" portal-element-news-doc-add" onMouseOver={() => this.setState({isShowAdd: true})} onMouseLeave={() => this.setState({isShowAdd: false})}>
                <div title='新建文档' className={`portal-element-news-doc-add-icon ${this.state.isShowAdd ? '' : 'portal-element-news-doc-add-hidden'}`} onMouseOver={() => this.setState({color: '#434343'})} onMouseLeave={() => this.setState({color: '#939393'})} onClick={this.handleOpen} style={{color: this.state.color}}><img src='/spa/portal/images/news_add.png' alt=''/></div>
                {children}
            </div>
        }
        return <div>{children}</div>
    }
}

class ImgCom extends React.Component {
    constructor(props) {
        super(props);
        this.aClick = this.aClick.bind(this);
    }
    aClick () {
        const { link = '', linkmode='1'} = this.props;
        if(link != ''){
            openLinkUrl(link, linkmode);
            // window.open(link, linkmode);
        }else return false;
    }
    render() {
        const {src = '', style = {width: '100%', height: '100%'}} = this.props;
        return (
            <a href="javascript:void(0)" onClick={this.aClick}>
                <img alt="" style={style} src={src}/>
            </a>
        );
    }
}
import { WeaErrorPage, WeaTools } from 'ecCom';
class MyErrorHandler extends React.Component {
    render() {
        const hasErrorMsg = this.props.error && this.props.error !== "";
        return (
            <WeaErrorPage msg={hasErrorMsg?this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")} />
        );
    }
}
NewsType = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(NewsType);
export default NewsType;





// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/news_dy/NewsType.js